
import { Component, Vue } from 'vue-property-decorator'

import { authExternal } from '@/helpers/AuthExternal'

import { openLoginModal } from '@/modals/loginModal'

@Component({
  name: 'LoginLink',
})
export default class extends Vue {
  onClick() {
    if (authExternal.isExternalAuth()) {
      void authExternal.login(this.$route.fullPath)
    } else {
      openLoginModal()
        .then(() => this.$emit('success'))
        // TODO Reject the promise from openLoginModal() when the modal is dismissed.
        .catch(() => this.$emit('dismissed'))
    }
  }
}
